<a [routerLink]="['/shop/wishlist']" style="position: relative; color: white;">
  <i class="fa fa-heart" aria-hidden="true" style="color: white;"></i>Wishlist
  <span class="cart_qty_cls" style="border: 1px solid white;">{{ WishlistCount }}</span>
</a>
